import { render, staticRenderFns } from "./marketLogList.vue?vue&type=template&id=1b54da31&scoped=true"
import script from "./marketLogList.vue?vue&type=script&lang=js"
export * from "./marketLogList.vue?vue&type=script&lang=js"
import style0 from "./marketLogList.vue?vue&type=style&index=0&id=1b54da31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b54da31",
  null
  
)

export default component.exports